<template>
  <div style="padding: 10px">
    <div style="background: #fff; border-radius: 8px; padding: 20px;">
      <br />
      <CheckboxGroup v-model="border">
        <Checkbox label="00000018003155" border></Checkbox>
        <Checkbox label="00000018004345" border></Checkbox>
        <Checkbox label="00000018004361" border></Checkbox>
        <Checkbox label="00000018004457" border></Checkbox>
        <Checkbox label="00000018004523" border></Checkbox>
        <Checkbox label="00000018004635" border></Checkbox>
        <Checkbox label="00000018004782" border></Checkbox>
        <Checkbox label="00000018004789" border></Checkbox>
        <Checkbox label="00000018004798" border></Checkbox>
        <Checkbox label="00000018004799" border></Checkbox>
        <Checkbox label="00000018004850" border></Checkbox>
        <Checkbox label="00000018005048" border></Checkbox>
        <Checkbox label="00000018005051" border></Checkbox>
        <Checkbox label="00000018005064" border></Checkbox>
        <Checkbox label="00000018005332" border></Checkbox>
        <Checkbox label="00000018005388" border></Checkbox>
        <Checkbox label="00000018005401" border></Checkbox>
        <Checkbox label="00000018005405" border></Checkbox>
        <Checkbox label="00000018005456" border></Checkbox>
        <Checkbox label="00000018005462" border></Checkbox>
      </CheckboxGroup>
      <br />
      <!-- <Page :total="100" show-sizer show-elevator /> -->
      <Button style="margin-left:10px" type="primary" icon="ios-search" @click="onDownMessage">下发默认参数</Button>
    </div>
  </div>
</template>

<script>
export default {
  name: "downmessage",
  data() {
    return {
      tableHeight: "200",
      border: []
    };
  },
  methods: {

    onDownMessage() {
      console.log(this.border);
      this.downMessage();
    },
    
    downMessage() {
      var that = this;
      this.$axios
        .post("/api/message/downParamMessage", {
          address: this.border
        })
        .then(function(res) {
          console.log(res);
          if(res.errorCode == 0){
            that.$Modal.success({
                            title: "提示",
                            content: "下发成功，等待设备获取"
                        });
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    }
  },
  mounted() {
    // this.showPage();
    let that = this;
    window.addEventListener("resize", function() {
      that.tableHeight = (window.innerHeight - 186) * 0.8;
    });
    that.tableHeight = (window.innerHeight - 186) * 0.8;
  }
};
</script>

<style scoped>
</style>